<template>
    <div class="branded-attribute" :class="{ highlight }">
        <Icon v-if="icon" :type="icon.type" :color="icon.color" size="s" />
        {{ attribute.description }}
    </div>
</template>

<script lang="ts">
    import { computed, PropType } from 'vue';
    import { BrandedAttributeItem } from '@ui/components/BrandedFares/BrandedCard/BrandedCard.interfaces';
    import { FlightBrandedAttributeStatus } from '@shared/interfaces/brandedFares';
    import {
        Type as IconType,
        Color as IconColor,
    } from '@ui/components/Icon/Icon.interfaces';
    import Icon from '@ui/components/Icon/Icon.vue';

    interface IconProps {
        type: IconType;
        color: IconColor;
    }

    export default {
        name: 'BrandedAttribute',
        components: { Icon },
        props: {
            attribute: {
                type: Object as PropType<BrandedAttributeItem>,
                required: true,
            },
            highlightIncluded: {
                type: Boolean,
                required: true,
            },
        },
        setup(props) {
            const icon = computed<IconProps | undefined>(() => {
                switch (props.attribute.status) {
                    case FlightBrandedAttributeStatus.Chargeable:
                        return { type: 'InfoCircle', color: 'lightGrey' };
                    case FlightBrandedAttributeStatus.Included:
                        return { type: 'Check', color: 'jungle' };
                    case FlightBrandedAttributeStatus.NotOffered:
                        return { type: 'Cross', color: 'lightGrey' };
                    default:
                        return undefined;
                }
            });

            const highlight = computed(
                () =>
                    props.attribute.status === FlightBrandedAttributeStatus.Included &&
                    props.highlightIncluded
            );

            return {
                icon,
                highlight,
            };
        },
    };
</script>
<style lang="scss" scoped>
    @forward 'Attribute';
</style>
